export default {
	firebaseConfig: {
    apiKey: "AIzaSyCSsaWYZDRU8aHgk6lizNIMxUH4PGK36Js",
    authDomain: "mg-dealer-media.firebaseapp.com",
    databaseURL: "https://mg-dealer-media.firebaseio.com",
    storageBucket: "mg-dealer-media.appspot.com",
    messagingSenderId: "34171813158"
	}
};



// WEBPACK FOOTER //
// ./src/firebase/config-media.js